import Chartist, { Line } from "chartist";

export default class Chart {
  constructor() {
    this.chart = document.querySelectorAll(".ct-chart");
    if (this.chart.length > 0) this.init();
  }

  init() {
    let data = {
      // Our series array that contains series objects or in this case series data arrays
      series: [[1, 4, 9, 10, 12, 20]]
    };

    let options = {
      showPoint: true,
      showLine: true,
      showArea: false,

      fullWidth: true,
      showLabel: false,

      axisX: {
        showGrid: false,
        showLabel: false,
        offset: 0
      },

      axisY: {
        showGrid: true,
        showLabel: false,
        offset: 0
      },

      chartPadding: 0,
      low: 0
    };

    // Create a new line chart object where as first parameter we pass in a selector
    // that is resolving to our chart container element. The Second parameter
    // is the actual data object.
    new Chartist.Line(".ct-chart", data, options);
  }
}
